<template>
  <span class="measured-mtbf">
    <span v-if="text" class="mtbf-value">{{ text }}</span>
    <v-icon v-if="icon" :color="iconColor" small>{{ icon }}</v-icon>
  </span>
</template>

<script>
import { Duration } from 'luxon'

export default {
  name: 'MeasuredMtbf',
  props: {
    value: {
      type: String,
      description: 'Latest measured MTBF value'
    },
    previousMtbf: {
      type: String,
      description: 'Previously measured MTBF value'
    }
  },
  computed: {
    mtbf() {
      return this.value ? Duration.fromISO(this.value) : null
    },
    icon() {
      if (!this.mtbf) {
        return 'fa-regular fa-empty-set'
      } else if (!this.previousMtbf) {
        return null
      } else {
        let prevMtbf = Duration.fromISO(this.previousMtbf)
        if (this.mtbf > prevMtbf) {
          return 'fa-regular fa-arrow-trend-up'
        } else if (this.mtbf < prevMtbf) {
          return 'fa-regular fa-arrow-trend-down'
        } else {
          return null
        }
      }
    },
    iconColor() {
      if (!this.mtbf) {
        return null
      } else if (!this.previousMtbf) {
        return null
      } else {
        let prevMtbf = Duration.fromISO(this.previousMtbf)
        if (this.mtbf > prevMtbf) {
          return 'success'
        } else if (this.mtbf < prevMtbf) {
          return 'error'
        } else {
          return null
        }
      }
    },
    text() {
      return this.mtbf ? this.mtbf.toFormat("d'd'") : null
    }
  }
}
</script>

<style lang="scss" scoped>
.mtbf-value {
  margin-right: 8px;
}
</style>
